import {
    GET_DASHBOARD_DATA_REQUEST,
    GET_DASHBOARD_DATA_SUCCESS,
    GET_DASHBOARD_DATA_FAILURE,
    ADD_BOOKING_SUCCESS,
    ADD_BOOKING_FAILURE,
    ADD_BOOKING_REQUEST,
    GET_CASE_DETAILS_SUCCESS,
    GET_CASE_DETAILS_FAILURE,
    ADD_DENTIST_SUCCESS,
    ADD_DENTIST_FAILURE,
    ADD_DENTIST_REQUEST,
    ADD_PATIENT_DASHBOARD_SUCCESS,
    ADD_PATIENT_DASHBOARD_FAILURE,
    GET_CASE_DETAILS_REQUEST,
    GET_PARENT_CASES_REQUEST,
    GET_PARENT_CASES_SUCCESS,
    GET_PARENT_CASES_FAILURE,
    UPDATE_TABLE_CONFIG_SUCCESS,
    GET_ALL_PATIENTS_REQUEST,
    GET_ALL_PATIENTS_SUCCESS,
    GET_ALL_PATIENTS_FAILURE,
    GET_SMALL_CALENDAR_DATA_REQUEST,
    GET_SMALL_CALENDAR_DATA_SUCCESS,
    GET_SMALL_CALENDAR_DATA_FAILURE,
    GET_VACATION_DAYS_REQUEST,
    GET_VACATION_DAYS_SUCCESS,
    GET_VACATION_DAYS_FAILURE,
    ADD_VACATION_DAYS_REQUEST,
    ADD_VACATION_DAYS_SUCCESS,
    ADD_VACATION_DAYS_FAILURE,
    DELETE_VACATION_DAYS_SUCCESS,
    DELETE_VACATION_DAYS_FAILURE, DELETE_VACATION_DAYS_REQUEST, RESET_VACATIONS_SUCCESS,RESET_VACATIONS_DELETE
} from './constants';
import {
    EDIT_AVAILABLE_UNITS_SUCCESS,
    REMOVE_AVAILABLE_UNITS_FAILURE,
    REMOVE_AVAILABLE_UNITS_SUCCESS
} from "../AvailableUnits/constants";

const initialState = {
    loading: true,
    data: [],
    smallCalendarData: [],
    dentistInfo: undefined,
    added: undefined,
    addedData: undefined,
    caseList: undefined,
    patientAdded: undefined,
    addIsSuccess: undefined,
    patientInfo: undefined,
    gotCaseDetails: false,
    addingDataLoading: false,
    vacationDaysRequestLoading: false,
    parentCases: [],
    tableConfig: {},
    allPatientsList:[],
    vacationDays: [],
    deletedVacationDay:false,
    addedVacationDays:false,
};

const adminDashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DASHBOARD_DATA_REQUEST: {
            return Object.assign({}, state, {
                loading: false,
                added: undefined,
                addIsSuccess: undefined,
                patientAdded: undefined
            });
        }
        case GET_DASHBOARD_DATA_SUCCESS: {
            return Object.assign({}, state, {
                loading: false,
                added: undefined,
                data: action.data,
                addIsSuccess: undefined,
                patientAdded: undefined
            });
        }
        case GET_DASHBOARD_DATA_FAILURE: {
            return Object.assign({}, state, {
                loading: false,
                added: undefined,
                data: [],
                addIsSuccess: undefined,
                patientAdded: undefined
            });
        }
        case GET_SMALL_CALENDAR_DATA_REQUEST: {
            return Object.assign({}, state, {
                loading: false,
                added: undefined,
                addIsSuccess: undefined,
                patientAdded: undefined
            });
        }
        case GET_SMALL_CALENDAR_DATA_SUCCESS: {
            return Object.assign({}, state, {
                loading: false,
                added: undefined,
                smallCalendarData: action.data,
                addIsSuccess: undefined,
                patientAdded: undefined
            });
        }
        case GET_SMALL_CALENDAR_DATA_FAILURE: {
            return Object.assign({}, state, {
                loading: false,
                added: undefined,
                smallCalendarData: [],
                addIsSuccess: undefined,
                patientAdded: undefined
            });
        }
        case ADD_BOOKING_REQUEST: {
            return Object.assign({}, state, {
                loading: false,
                addingDataLoading: true,
                added: undefined,
                addIsSuccess: undefined,
                patientAdded: undefined
            });
        }
        case ADD_BOOKING_SUCCESS: {
            return Object.assign({}, state, {
                loading: false,
                addingDataLoading: false,
                added: true,
                data: action.data,
                addedData: action.data.bookingId,
                addIsSuccess: undefined,
                patientAdded: undefined
            });
        }
        case ADD_BOOKING_FAILURE: {
            return Object.assign({}, state, {
                loading: false,
                addingDataLoading: false,
                added: false,
                data: [],
                addedData: undefined,
                addIsSuccess: undefined,
                patientAdded: undefined
            });
        }
        case GET_CASE_DETAILS_SUCCESS: {
            return Object.assign({}, state, {
                loading: false,
                gotCaseDetails: true,
                added: undefined,
                caseList: action.data,
                addIsSuccess: undefined,
                patientAdded: undefined
            });
        }
        case GET_CASE_DETAILS_FAILURE: {
            return Object.assign({}, state, {
                loading: false,
                added: undefined,
                gotCaseDetails: false,
                caseList: undefined,
                addIsSuccess: undefined,
                patientAdded: undefined
            });
        }
        case GET_CASE_DETAILS_REQUEST: {
            return Object.assign({}, state, {
                loading: false,
                added: undefined,
                gotCaseDetails: false,
                caseList: undefined,
                addIsSuccess: undefined,
                patientAdded: undefined
            });
        }
        case ADD_DENTIST_REQUEST:
            return state;
        case ADD_DENTIST_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                added: undefined,
                caseList: undefined,
                addIsSuccess: true,
                patientAdded: undefined,
                dentistInfo: action.data
            });
        case ADD_DENTIST_FAILURE:
            return Object.assign({}, state, {
                loading: false,
                added: undefined,
                caseList: undefined,
                addIsSuccess: false,
                patientAdded: undefined
            });
        case ADD_PATIENT_DASHBOARD_SUCCESS: {
            return Object.assign({}, state, {
                loading: false,
                added: undefined,
                caseList: undefined,
                addIsSuccess: undefined,
                patientAdded: true,
                patientInfo: action.data.patient
            });
        }
        case ADD_PATIENT_DASHBOARD_FAILURE: {
            return Object.assign({}, state, {
                loading: false,
                added: undefined,
                caseList: undefined,
                addIsSuccess: undefined,
                patientAdded: false
            });
        }
        case GET_PARENT_CASES_REQUEST: {
            return Object.assign({}, state, {loading: true, parentCases: []});
        }
        case GET_PARENT_CASES_SUCCESS: {
            return Object.assign({}, state, {
                loading: false,
                parentCases: action.data.cases,
                tableConfig: {...action.data.tableConfig, filter: true}
            });
        }
        case GET_PARENT_CASES_FAILURE: {
            return Object.assign({}, state, {loading: false, parentCases: []});
        }
        case UPDATE_TABLE_CONFIG_SUCCESS: {
            return Object.assign({}, state, {tableConfig : {...action.data, filter: true}});
        }
        case GET_ALL_PATIENTS_REQUEST: {
            return Object.assign({}, state, {loading: true});
        }
        case GET_ALL_PATIENTS_SUCCESS: {
            return Object.assign({}, state, {loading: false, allPatientsList: action.data.patientsList, totalCount: action.data.totalCount});
        }
        case GET_ALL_PATIENTS_FAILURE: {
            return Object.assign({}, state, {loading: false, allPatientsList: []});
        }
        case GET_VACATION_DAYS_SUCCESS: {
            return Object.assign({}, state, {
                vacationDays: action.data,
                vacationDaysRequestLoading: false
            });
        }
        case GET_VACATION_DAYS_REQUEST: {
           return Object.assign({}, state, {
                vacationDaysRequestLoading: true
            });
        }
        case GET_VACATION_DAYS_FAILURE: {
            return Object.assign({}, state, {
                vacationDays: {},
                vacationDaysRequestLoading: false
            });
        }
        case ADD_VACATION_DAYS_REQUEST: {
            return Object.assign({}, state, {
                addingVacationDaysLoading: true,
                addedVacationDays: false,
            });
        }
        case ADD_VACATION_DAYS_SUCCESS: {
            return Object.assign({}, state, {
                addingVacationDaysLoading:false,
                //vacationDays: action.data, Not update vacation days,bcs it will automate update id from dashboard.js after componentUpdate
                addedVacationDays: true,
            });
        }
        case ADD_VACATION_DAYS_FAILURE: {
            return Object.assign({}, state, {
                addingVacationDaysLoading:false,
                vacationDays: {},
                addedVacationDays: false,
            });
        }
        case RESET_VACATIONS_SUCCESS: {
            return Object.assign({}, state, {
                addingVacationDaysLoading:false,
                addedVacationDays: false,
            });
        }
        case RESET_VACATIONS_DELETE: {
            return Object.assign({}, state, {
                deletedVacationDay:false,
            });
        }
        case DELETE_VACATION_DAYS_SUCCESS: {
            return Object.assign({}, state, {
                deletedVacationDay: true,
                loadingVacationDay: false,
                //data: action.data same comment ADD_VACATION_DAYS_SUCCESS
            });
        }
        case DELETE_VACATION_DAYS_FAILURE: {
            return Object.assign({}, state, {deletedVacationDay: false, loadingVacationDay: false, data: {}});
        }
        case DELETE_VACATION_DAYS_REQUEST: {
            return Object.assign({}, state, {deletedVacationDay: false, loadingVacationDay: true, data: {}});
        }
        default: {
            return state;
        }
    }
};

export default adminDashboardReducer;



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/dashboard/reducer.js